export const CANNOT_DISABLE_NON_CUSTOM_TEAM_ROLES_ERROR = 'Cannot disable non-custom team user roles when there are users with non-custom team roles';
